import  en from './en.json'
import  ru from './ru.json'

export const defaultLocale= 'ru'

export const language = {
    en,
    ru
}